// assets/teletype-label.js
document.addEventListener('DOMContentLoaded', function() {
  if (window.teletypeLabelInitialized) return;
  window.teletypeLabelInitialized = true;

  const messages = [
    "What are you looking for?",
    "Tap here to search",
    "Search all products quickly and easily..."
  ];

  const inputs = document.querySelectorAll('.field__input.search__input');
  let currentMessageIndex = 0;
  let currentCharIndex = 0;
  let typingTimeout;
  let erasingTimeout;
  let isPaused = false;

  function typeMessage() {
    if (isPaused) return;
    if (currentCharIndex < messages[currentMessageIndex].length) {
      inputs.forEach(input => {
        input.placeholder += messages[currentMessageIndex].charAt(currentCharIndex);
      });
      currentCharIndex++;
      typingTimeout = setTimeout(typeMessage, 100); // Adjust typing speed here
    } else {
      erasingTimeout = setTimeout(eraseMessage, 2000); // Adjust delay before erasing here
    }
  }

  function eraseMessage() {
    if (isPaused) return;
    inputs.forEach(input => {
      input.placeholder = '';
    });
    currentCharIndex = 0;
    currentMessageIndex = (currentMessageIndex + 1) % messages.length;
    typingTimeout = setTimeout(typeMessage, 500); // Adjust delay before typing next message here
  }
    typeMessage();
});